import checkInApis from 'features/checkIn/services/apis';
import { IResponseDataBody } from 'services/response';
import { IExitsAppointmentData } from '../types/booking';

const useGetExitsAppointment = (openWarningExitsAppointment: (data: IExitsAppointmentData) => void) => {
  const mute = async (customerId: string, date: string) => {
    try {
      const res: IResponseDataBody<IExitsAppointmentData> = await checkInApis.checkExitsAppointment({
        customerId: customerId,
        date: date,
      });
      if (res.data.data) {
        openWarningExitsAppointment(res.data.data);
      }
    } catch (error) {}
  };

  return [mute];
};

export default useGetExitsAppointment;
